import React from "react";
import { formatInUserTimezone } from "../../../utils/timezone";

const DAYS = [14, 30, 60];

function SRStaleLeads({
  items, days, onDaysChange, loading, error, onOpenLead, onViewAll,
}) {
  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-hourglass-half" />
        <span>Stale Leads</span>
        <div className="sr-stale-switch">
          {DAYS.map((d) => (
            <button
              key={d}
              type="button"
              className={`sr-stale-switch-btn ${days === d ? "active" : ""}`}
              onClick={() => onDaysChange(d)}
            >
              {d}d
            </button>
          ))}
        </div>
      </div>
      <div className="dashboard-card-v2-body">
        {error ? (
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
          </div>
        ) : loading ? (
          <div className="dashboard-skeleton-list">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="dashboard-skeleton-row" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-check-circle" />
            <p>No leads stale for {days}+ days.</p>
          </div>
        ) : (
          <div className="sr-stale-list">
            {items.map((lead) => (
              <button
                type="button"
                key={lead.lead_id}
                className="sr-stale-item"
                onClick={() => onOpenLead(lead.lead_id)}
              >
                <div className="sr-stale-info">
                  <strong>{lead.company || "Unnamed Dealership"}</strong>
                  <span>
                    {lead.status} · Last touched {formatInUserTimezone(lead.updated_at)}
                  </span>
                </div>
                <div className="sr-stale-badge">{Number(lead.days_stale || 0)}d</div>
              </button>
            ))}
          </div>
        )}
      </div>
      {onViewAll && !loading && items.length > 0 && (
        <button type="button" className="dashboard-card-v2-footer-link" onClick={onViewAll}>
          View all stale leads ({days}d+)
          <i className="fas fa-arrow-right" />
        </button>
      )}
    </div>
  );
}

export default SRStaleLeads;